import {
  ADMIN_SIGNALS_PATH,
  BASE_GROUP_MANAGEMENT_PATH,
  DASHBOARD_PATH,
  IS_WHOP,
} from "common/constants.ts";
import { WorkspaceType } from "@shared/types";

export const workspaceToDefaultPath = {
  [WorkspaceType.ADMIN]: IS_WHOP
    ? ADMIN_SIGNALS_PATH
    : BASE_GROUP_MANAGEMENT_PATH,
  [WorkspaceType.USER]: DASHBOARD_PATH,
  [WorkspaceType.DEMO]: DASHBOARD_PATH,
};

export const HEADER_HEIGHT = 80;
export const MOBILE_HEADER_HEIGHT = 56;
export const BOTTOM_SPACER_HEIGHT = 90;
